// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__39EjL","DarkLogo":"Logo_DarkLogo__1Z89e","Star":"Logo_Star__1IPcD","Small":"Logo_Small__3h3bB"};